import { IconCheck } from "@tabler/icons-react";

import { cn } from "@/lib/utils";
import type { RatioGroupKey } from "@/config/contentProgramUpload";
import { MediaFrame, TileFoot } from "@/components/content-programs/media-tile";
import type { MetaCampaignContent } from "@/services/metaAdsCampaignProgram.service";

export interface ApprovedContentPortraitTileProps {
  creative: MetaCampaignContent;
  selected: boolean;
  /** Distinct `name` per radio group on the page */
  radioName: string;
  onSelect: () => void;
  ratio?: RatioGroupKey;
}

/**
 * A creative to pick for an ad. Every tile here is approved, so nothing
 * says so; the chosen one carries the brand ring and a check.
 */
export function ApprovedContentPortraitTile({
  creative: c,
  selected,
  radioName,
  onSelect,
  ratio = "9:16",
}: ApprovedContentPortraitTileProps) {
  const poster = c.thumbnailUrl || (c.mediaType === "IMAGE" ? c.mediaUrl : null);
  const title = c.title?.trim() || "Untitled";

  return (
    <label
      aria-label={`Use ${title}`}
      className="group block w-full cursor-pointer rounded-md has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-ring has-[:focus-visible]:ring-offset-2 has-[:focus-visible]:ring-offset-card"
    >
      <input type="radio" name={radioName} className="peer sr-only" checked={selected} onChange={onSelect} />
      <MediaFrame
        ratio={ratio}
        poster={poster}
        isVideo={c.mediaType === "VIDEO"}
        selected={selected}
        className={cn(!selected && "group-hover:ring-foreground/30")}
      >
        <span
          aria-hidden
          className={cn(
            "absolute right-2 top-2 z-10 flex size-5 items-center justify-center rounded-full border border-white/80 transition-colors",
            selected ? "bg-brand-600 text-brand-contrast" : "bg-black/35 text-transparent group-hover:bg-black/50"
          )}
        >
          <IconCheck size={12} stroke={3} />
        </span>
        <TileFoot title={title} note={c.destinationUrl?.replace(/^https?:\/\//, "")} />
      </MediaFrame>
    </label>
  );
}
